import React from 'react'
import { ADMIN_ROUTES } from '@constants/routes'
import PageWrapper from 'Pages/@PageWrapper'
import AdminMappingPageContent from 'Pages/Admin/AdminMapping/Content'


export default function AdminMappingPage() {

	return <PageWrapper
		head={`DS Rentacar | ${ADMIN_ROUTES.TITLE}`}
		title={ADMIN_ROUTES.TITLE}
		subtitle={ADMIN_ROUTES.ADMIN_MAPPING_SUBTITLE}
		isEmpty={false}
	>
		<AdminMappingPageContent/>
	</PageWrapper>
}